class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Enable hover functionality on desktop
    this.setupHoverBehavior();
  }

  setupHoverBehavior() {
    // Only enable hover on non-touch devices
    const mediaQuery = window.matchMedia('(min-width: 990px)');

    if (mediaQuery.matches) {
      this.enableHover();
    }

    mediaQuery.addEventListener('change', (e) => {
      if (e.matches) {
        this.enableHover();
      } else {
        this.disableHover();
      }
    });
  }

  enableHover() {
    this.hoverTimeout = null;

    this.mouseEnterHandler = () => {
      clearTimeout(this.hoverTimeout);
      this.open();
    };

    this.mouseLeaveHandler = () => {
      // Small delay before closing to prevent accidental close
      this.hoverTimeout = setTimeout(() => {
        this.close();
      }, 150);
    };

    this.addEventListener('mouseenter', this.mouseEnterHandler);
    this.addEventListener('mouseleave', this.mouseLeaveHandler);
  }

  disableHover() {
    if (this.mouseEnterHandler) {
      this.removeEventListener('mouseenter', this.mouseEnterHandler);
    }
    if (this.mouseLeaveHandler) {
      this.removeEventListener('mouseleave', this.mouseLeaveHandler);
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
